import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  selector: 'app-link-button',
  template: `
    <app-base-button
      [baseClass]="''"
      [disabled]="disabled"
      (onClick)="onClick.emit($event)"
      stateColorScheme="surface"
    >
      <div class="" [ngClass]="color">
        <div class="text-start">
          <i *ngIf="leftIcon" class="fas mr-1" [class]="leftIcon"></i>
          <span class="underline text-sm" [class]="font">{{ text }}</span>
          <i *ngIf="rightIcon" class="fas ml-1 text-sm" [class]="rightIcon"></i>
        </div>
      </div>
    </app-base-button>
  `
})
export class LinkButtonComponent {
  @Input() text: string = 'Action';
  @Input() font: string = 'font-bold';
  @Input() color: string = 'text-theme-text3';
  @Input() leftIcon?: string;
  @Input() rightIcon?: string;
  @Input() disabled: boolean = false;
  @Output() onClick = new EventEmitter<MouseEvent>();
}
